<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import moment from 'moment'
import { incomeExpenseReportService } from "../../../../services/reportservice/incomeexpensereport.service.js";

const XLSX = require("xlsx");

/* eslint-disable no-console */
export default {

  page: {
    title: "Income Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
    Input
  },
  data() {
    return {
      title: "Income Report",
      data: [],
      date: '',
      projects: {},
      projectIncome: 0,
      otherIncome: 0,
      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),

      dataProjectId: 0,
      s_date: '',
      e_date: '',
      property_code: '',
      customer: '',
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();

    // const recaptchaScript = document.createElement("script");
    // recaptchaScript.setAttribute(
    //   "src",
    //   "https://unpkg.com/xlsx@0.15.1/dist/xlsx.full.min.js"
    // );
    // document.head.appendChild(recaptchaScript);
    
  },
  methods: {
    
    loadingData: function() {
      this.fetchingStats = false;
      incomeExpenseReportService.getIncomeDaily()
        .then(response => {
            this.fetchingStats = true;
            this.data = response.data.result;
            console.log(this.data);

            this.date = response.data.s_date;
            this.s_date = response.data.s_date;
            this.e_date = response.data.e_date;
            this.projects = response.data.projects;
            this.projectIncome = response.data.smmary.project_income;
            this.otherIncome = response.data.smmary.other_income;
            this.projecttName = response.data.project_name;
        });
    },
   
    submitSearch: function() {
      let param = '?project_id='+this.dataProjectId+
        '&s_date='+this.s_date + 
        '&e_date='+this.e_date + 
        '&customer='+this.customer + 
        '&property_code='+this.property_code;
        
      incomeExpenseReportService.getIncomeDaily(param)
        .then(response => {
            this.data = response.data.result;
            this.date = response.data.s_date;
            this.s_date = response.data.s_date;
            this.e_date = response.data.e_date;
            this.projectIncome = response.data.smmary.project_income;
            this.otherIncome = response.data.smmary.other_income;
            this.projectName = response.data.project_name.name +'('+response.data.project_name.name_en+')';
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    numberFormat(value) {
      if(!value){
        return '';
      }
      let sign = '';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
      // this.exportToExcel('xlsx');
    },
    total(column) {
      return this.data.reduce(function (sum, item) {
        return sum + item[column];
      }, 0)
    },

    exportToExcel(type, fn, dl) {

      // console.log(type);

      let name = "dialyincome";

      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {sheet:"Daily Income"});
      return dl ?
        XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
      XLSX.writeFile(wb, fn || ((name + '.'|| 'SheetJSTableExport.') + (type || 'xlsx')));
    },


  },
  computed: {
    total_amount_cash() {
      return this.data.reduce(function (sum = 0, item) {
        return sum + item.amount_cash;
      }, 0)
    },
    total_amount_cheque() {
      return this.data.reduce(function (sum = 0, item) {
        return sum + item.amount_cheque;
      }, 0)
    },
    total_amount_aba8007() {
      return this.data.reduce(function (sum = 0, item) {
        return sum + item.amount_aba8007;
      }, 0)
    },
    total_amount_aba8006() {
      return this.data.reduce(function (sum = 0, item) {
        return sum + item.amount_aba8006;
      }, 0)
    },
    total_amount_acleda347() {
      return this.data.reduce(function (sum = 0, item) {
        return sum + item.amount_acleda347;
      }, 0)
    },
    total_amount() {
      return this.data.reduce(function (sum = 0, item) {
        return sum + item.amount;
      }, 0)
    }
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('report.income_expense.daily_income')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              <div class="col-sm-2">
                  <Input 
                    :type="'text'"
                    :id="'property_code'"
                    v-model="property_code"
                    :label="'general.property'"
                    @enter="submitSearch()"
                      /> 
              </div>
              <div class="col-sm-2">
                  <Input 
                    :type="'text'"
                    :id="'customer'"
                    v-model="customer"
                    :label="'general.customer'" 
                    @enter="submitSearch()"
                      /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('project.text')}}</label>
                <Select
                    :id="'id'"
                    :text="'label'"
                    :editable="true"
                    :list="{data: this.projects}"
                    v-model="dataProjectId"
                    /> 
                </div>
                <div class="col-sm-2">
                    <label>{{$t('general.start-date')}}</label>
                    <Input 
                    :type="'date'"
                    :id="'start_date'"
                    v-model="s_date"
                    /> 
                </div>
                <div class="col-sm-2">
                    <label>{{$t('general.end-date')}}</label>
                    <Input 
                    :type="'date'"
                    :id="'end_date'"
                    v-model="e_date"
                    /> 
                </div>
              <div class="col-sm-2">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>

              <div class="col-sm-2">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="exportToExcel('xlsx')" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="'gfdgd'" 
                />
              </div>

          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td style="8%"><p>&nbsp;</p></td>
                <td width="60%"><p>&nbsp;</p></td>
                <td width="32%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 078 55 40 77 | 015 55 40 77 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <h4 class="khb"><u>{{$t('report.text')+$t('report.income_expense.daily_income')}}</u></h4>
                    <!-- <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p> -->
                    <p class="khb"><u>កាលរិច្ឆេទ: {{this.dateFormat(s_date)}} - {{this.dateFormat(e_date)}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table ref="exportable_table" id="to_excel_tble" class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th style="width:5em;" rowspan="2">{{$t('general.number')}}</th>
                  <th style="width:7em;" rowspan="2">{{$t('general.project')}}</th>
                  <th style="width:7em;" rowspan="2">{{$t('general.property')}}</th>
                  <th style="width:12em;" rowspan="2">{{$t('general.customer_name')}}</th>
                  <th style="width:8em;" rowspan="2">{{$t('general.pay-date')}}</th>
                  <th style="width:7em;"  rowspan="2">{{$t('general.reciept_code')}}</th>
                  <th style="width:30em;" rowspan="2">{{$t('general.description')}}</th>
                  <th colspan="6">{{$t('general.payment_property')}}</th>
                </tr>
                <tr class="thead">
                  <th style="width:7em;">{{$t('general.cash')}}</th>
                  <th style="width:7em;">{{$t('general.checque')}}</th>
                  <th style="width:7em;">{{$t('general.aba8007')}}</th>
                  <th style="width:7em;">{{$t('general.aba8006')}}</th>
                  <th style="width:7em;">{{$t('general.acleda347')}}</th>
                  <th style="width:7em;">{{$t('general.total')}}</th>
                </tr>
              
              <tbody>
                  <tr v-for="(list, index) in data" :key="index" >
                    <td>{{index + 1}}</td>
                    <td>{{list.project_name}}</td>
                    <td>{{list.property_code}}</td>
                    <td>{{list.customer_name}}</td>
                    <td>{{list.pay_date}}</td>
                    <td>{{list.code}}</td>
                    <td>{{list.description}}</td>
                    <td>{{formatCurrency(list.amount_cash)}}</td>
                    <td>{{formatCurrency(list.amount_cheque)}}</td>
                    <td>{{formatCurrency(list.amount_aba8007)}}</td>
                    <td>{{formatCurrency(list.amount_aba8006)}}</td>
                    <td>{{formatCurrency(list.amount_acleda347)}}</td>
                    <td>{{formatCurrency(list.amount)}}</td>
                  </tr>
                </tbody>
                    <tr class="tfoot" v-if="data">
                        <td colspan="7" class="text-end pe-2">{{$t('report.total')}}</td>
                        <td>{{formatCurrency(total_amount_cash)}}</td>
                        <td>{{formatCurrency(total_amount_cheque)}}</td>
                        <td>{{formatCurrency(total_amount_aba8007)}}</td>
                        <td>{{formatCurrency(total_amount_aba8006)}}</td>
                        <td>{{formatCurrency(total_amount_acleda347)}}</td>
                        <td>{{formatCurrency(total_amount)}}</td>
                    </tr>
            </table>
            <br>
            <table class="content-general h8 project-sumary-table report-table" width="30%">
                
                    <tr class="thead">
                    <th rowspan="2">{{$t('general.number')}}</th>
                    <th rowspan="2">{{$t('report.income_expense.income_by_project')}}</th>
                    <th rowspan="2">{{$t('report.income_expense.total_income')}}</th>
                    </tr>
                
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>អេច សែនសុខ</td>
                        <td>{{formatCurrency(projectIncome)}}</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>ចំណួលផ្សេងៗ</td>
                        <td>{{formatCurrency(otherIncome)}}</td>
                    </tr>
                    <tr>
                        <td colspan="2">{{$t('report.total')}}</td>
                        <td>{{formatCurrency(projectIncome + otherIncome)}}</td>
                    </tr>
                </tbody>
              
            </table>
       
            <div class="row mt-3 report-table">
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <p class="mt-5">លឹម ទ្រី</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4"><br>ទទួលសាច់ប្រាក់ដោយ</p>
                  <p class="mt-5"><br></p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <p class="mt-5">..........................</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>ប្រធានគណនេយ្យ</p>
                   <p class="mt-5">..........................</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">កត់ត្រាដោយ<br>ផ្នែកបេឡា</p>
                   <p class="mt-5">{{this.user.name}}</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>